import AxiosPermisos  from './../../../axiosPermisos'

import {
  paths
} from './path'

import {
  map_query
} from '@/core/functions/map-path-query'

async function htGESDashboardSVE (id = 0) {
  const url = paths.htGesDashboardSVE.concat(`/${id}`)
  return await AxiosPermisos.get(url, true, 'v2')
}

async function htGESDashboardSVEChangePageType (id = 0, data = {}) {
  const url = paths.htGesDashboardSVE.concat(`/${id}${(map_query(data))}`)
  return await AxiosPermisos.get(url, true, 'v2')
}

export {
  htGESDashboardSVE,
  htGESDashboardSVEChangePageType
}